import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
    Form, Input, FormFeedback, Label, Modal, ModalHeader, ModalBody, Button, UncontrolledTooltip
} from "reactstrap";


//redux
import { useSelector, useDispatch } from "react-redux";
import toastr from "toastr";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { mailInviteSurvey, viewParticipantProfile } from "store/actions";
import { withTranslation } from "react-i18next";
import { fetchLanguageList, getTemplate } from "helpers/backend_api_helper";
import { useGoogleLogin } from '@react-oauth/google';
import axios from "axios";
import { WithContext as ReactTags } from 'react-tag-input';
import { CopyToClipboard } from "react-copy-to-clipboard";

const KeyCodes = {
    comma: 188,
    enter: 13
};

const delimiters = [KeyCodes.comma, KeyCodes.enter];
function validateEmail(email) {
    // Regular expression for validating email addresses
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
}


const MailPopupModal = props => {
    const { modal, toggle, isEdit, itemData, fetchlistRaters } = props
    const [mailData, setMailData] = useState();
    const [languageList, setLanguageList] = useState()
    const [emailContentToCopy, setEmailContentToCopy] = useState("");
    const { error, success, loading } = useSelector(state => ({
        loading: state.AspirationQuestion.loading,
        error: state.AspirationQuestion.error,
        success: state.AspirationQuestion.success,
    }));
    const dispatch = useDispatch();

    useEffect(() => {
        setMailData(itemData)
    }, [itemData]);


    // fetch language
    const fetchLanguageLists = async () => {
        const listLang = await fetchLanguageList();
        setLanguageList(listLang?.data)
    }

    useEffect(() => {
        fetchLanguageLists()
    }, [])

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            mailto: mailData?.mailto,
            language_id: 1
        },
        validationSchema: Yup.object({
            // mailto: Yup.string().required(`${props.t("Please Enter Mail To")}`),
            // language_id: Yup.string().required(props.t("Please Enter Language")),
        }),
        onSubmit: (values, { resetForm, setFieldValue }) => {
            console.log(values)
            values = {
                ...values,
                language_id: values?.language_id
            }

            setLoadingState(true)
            if (tags.length <= 0) {
                toastr.error(props.t("Please fill all fields"));
                setLoadingState(false)
                return
            }
            if (props?.profileData?.gmail_refresh_token) {
                let objValues = {
                    ...values,
                    mailto: tags?.map((data) => data.text),
                    rater_type: itemData?.id,
                    refresh_token: props?.profileData?.gmail_refresh_token
                }
                console.log("inside this ", objValues)
                dispatch(mailInviteSurvey(objValues, (res) => {
                    if (res?.status === 'success') {
                        toastr.success(res.message)
                        resetForm({
                            mailto: '',
                            language_id: '',
                            rater_type: '',
                            refresh_token: ''
                        });
                        setLoadingState(false)
                        setTags([])
                        fetchlistRaters()
                        toggle()
                    } else {
                        toastr.error(res.message || "Server Error")
                        validation.resetForm({
                            mailto: '',
                            language_id: '',
                            rater_type: '',
                            refresh_token: ''
                        });
                        setLoadingState(false)
                        setTags([])
                        toggle()
                    }
                }));

            } else {
                login()
            }
        }
    });


    // login by backend
    const clientId = "315592021987-op0ucdp74buh84mnj1a2pufm4t8gv6e0.apps.googleusercontent.com";
    const secret = "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";
    const [loadingState, setLoadingState] = useState(false);
    const login = useGoogleLogin({
        scope: 'openid https://mail.google.com https://www.googleapis.com/auth/userinfo.email',
        onSuccess: (codeResponse) => {
            getToken(codeResponse?.code);
        },
        onFailure: (error) => {
            setLoadingState(false)

        },
        flow: "auth-code",
    });

    const getToken = async (token) => {

        const params = new URLSearchParams();
        params.append("code", token);
        params.append("client_id", clientId);
        params.append("client_secret", secret);
        //   params.append("redirect_uri", "http://localhost:3000");
        params.append("redirect_uri", "https://schor-admin.suffescom.dev");
        params.append("grant_type", "authorization_code");
        try {
            const response = await axios.post(`https://oauth2.googleapis.com/token`, params, {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });
            let objValues = {
                ...validation?.values,
                mailto: tags?.map((data) => data.text),
                rater_type: itemData?.id,
                refresh_token: response?.data?.refresh_token
            }
            dispatch(mailInviteSurvey(objValues, (res) => {
                if (res?.status === 'success') {
                    toastr.success(res.message)
                    validation.resetForm({
                        mailto: '',
                        language_id: '',
                        rater_type: '',
                        refresh_token: ''
                    });
                    setLoadingState(false)
                    setTags([])
                    fetchlistRaters()
                    toggle()
                } else {
                    toastr.error(res.message || "Server Error")
                    validation.resetForm({
                        mailto: '',
                        language_id: '',
                        rater_type: '',
                        refresh_token: ''
                    });
                    setLoadingState(false)
                    setTags([])
                    toggle()
                }
            }));

        } catch (error) {
            validation.resetForm({
                mailto: '',
                language: '',
                mailfrom: '',
                access_token: '',
                refresh_token: ''
            });
            setLoadingState(false)
            setTags([])
            console.error("error", error);
        }
    };


    const [tags, setTags] = useState([]);
    const [errors, setErrors] = useState('');

    const handleDelete = i => {
        setTags(tags?.filter((tag, index) => index !== i));
    };

    const handleAddition = tag => {
        if (validateEmail(tag?.text)) {
            setTags([...tags, tag]);
            setErrors('');
        } else {
            setErrors('Invalid email address');
        }
    };

    const handleTagClick = index => {
    };
    const [mailTemplates, setMailTemplates] = useState(null)
    const fetchMailTemplate = async () => {
        console.log(itemData, mailData, validation?.values?.language_id)
        try {
            let objValues = {
                language_id: +validation?.values?.language_id || languageList[0]?.id,
                rater_type: itemData?.id || mailData?.id
            }

            const res = await getTemplate(objValues);
            if (res.data.code == '404') {
                setMailTemplates('');
                return toastr.error(res.message);
            } else {
                setMailTemplates(res?.data)
            }

        } catch (error) {
        }

    }

    useEffect(() => {
        // if(validation?.values?.language_id){
        //     fetchMailTemplate()
        // }
        fetchMailTemplate()

    }, [itemData, validation?.values?.language_id])

    const [loadingMail, setLoadingMail] = useState(false)
    const handleClick = () => {
        // fetchMailTemplate()
        if (!mailTemplates) {
            return toastr.error('Template Not Found');

        }

        setLoadingMail(true)
        // if (tags?.length <= 0) {
        //     // toastr.error(props.t("Please fill all fields"));
        //     setLoadingMail(false)
        //     return
        // }
        const recipients = tags?.map((data) => data.text);
        const subject = mailTemplates?.template_subject;
        const body = mailTemplates?.template_body;
        // const encodedBody = encodeURIComponent(body.replace(/\n/g, '<br>'));
        const bodyPlain = encodeURIComponent(body
            .replace(/<br\s*\/?>/gi, '\n') // Replace <br> tags with newlines
            .replace(/<[^>]+>/g, ''));

        const mailtoLink = `mailto:${recipients}?subject=${encodeURIComponent(subject)}&body=${bodyPlain}`;
        toggle();
        onResetForm();
        window.location.href = mailtoLink;
        setLoadingMail(false)
    };

    const onResetForm = () => {
        validation.resetForm({
            mailto: '',
            language_id: '',
            rater_type: '',
            refresh_token: ''
        });
        setErrors('');
        setLoadingState(false);
        setTags([])
    }

    return (
        <React.Fragment>
            <Modal isOpen={modal} toggle={
                () => {
                    toggle()
                    onResetForm()
                }}>
                <ModalHeader tag="h4" toggle={
                    () => {
                        toggle()
                        onResetForm()
                    }}>
                    {props.t("Invitation Send")}
                </ModalHeader>
                <ModalBody>
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                        }}
                    >
                        <div className="mb-3 d-block">
                            <Label className="form-label m-0 pb-1">{props.t("Language")}:</Label>
                            <Input
                                name="language_id"
                                className="form-control"
                                type="select"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.language_id || ""}
                                invalid={
                                    validation.touched.language_id && validation.errors.language_id ? true : false
                                }
                            >
                                {/* <option value="" disabled>{props.t("Select Language")}</option> */}
                                {
                                    languageList?.map((data, key) => {
                                        return (
                                            <option key={key} value={data?.id}>{data?.label}</option>
                                        )
                                    })
                                }
                            </Input>
                            {validation.touched.language_id && validation.errors.language_id ? (
                                <FormFeedback type="invalid">{validation.errors.language_id}</FormFeedback>
                            ) : null}
                        </div>

                        {/* Comment invitation tag code start here  */}
                        {/* <div className="mb-3 d-block custm-mail-selector">
                            <Label className="form-label m-0 pb-1">{props.t("Mail To")}:</Label>
                            <ReactTags
                                tags={tags}
                                delimiters={delimiters}
                                handleDelete={handleDelete}
                                handleAddition={handleAddition}
                                handleTagClick={handleTagClick}
                                inputFieldPosition="bottom"
                                autocomplete={false}
                                placeholder={props.t("Enter Mail...")}
                            />
                            {<div className="mail-error-custm">{props.t("(Note: Please Press Enter to Add New Mail.)")}</div>}


                        </div> */}
                        {/* Comment invitation tag code end here  */}
                        {errors && <div className="mail-error-custm">{errors}</div>}
                        <div className="d-flex custm-flex-btns">
                            {/* {
                            loadingState ?
                                <div className="btn-login-admin mt-3 batches-add-modal-btn">

                                    <button
                                        type="button"
                                        className="btn btn-primary btn-block d-flex"
                                        style={{width:"175px"}}
                                        disabled
                                    >
                                        <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                                        {props.t("Authorized & Send")}
                                    </button>
                                </div>
                                :
                                <div className="btn-login-admin mt-3 batches-add-modal-btn">
                                    <button
                                        className="btn btn-primary btn-block"
                                        style={mailTemplates ? {width:"160px"} : {width:"160px" , cursor:"not-allowed" ,"pointerEvents": "none"}}
                                        type="submit"
                                    >
                                        {props.t("Send from Gmail")}
                                    </button>
                                </div>
                        } */}
                            {
                                loadingMail ?
                                    <div className="btn-login-admin mt-3 batches-add-modal-btn">
                                        <span
                                            className="btn btn-primary btn-block send-invitation"
                                            style={{ width: "160px" }}
                                        >
                                            {props.t("Launching Mail...")}
                                        </span>
                                    </div>
                                    :
                                    <div className="btn-login-admin mt-3 batches-add-modal-btn">
                                        <span
                                            className="btn btn-primary btn-block send-invitation"
                                            style={mailTemplates ? { width: "160px" } : { width: "160px", background: '#3a7bbdc4 !important', cursor: "not-allowed", borderColor: '#3a7bbdc4 !important' }}
                                            onClick={() => {
                                                mailTemplates
                                                    ?
                                                    handleClick()
                                                    : ""
                                            }}
                                        >
                                            {props.t("Open Mail")}
                                        </span>

                                        <UncontrolledTooltip
                                            placement="top"
                                            target="emailContent"
                                        >
                                            {props.t("Click to Copy")}
                                        </UncontrolledTooltip>

                                        {/* <CopyToClipboard text={emailContentToCopy} onCopy={handleCopy}>
                                            <span
                                                id="emailContent"
                                                className="btn btn-primary btn-block"
                                                style={mailTemplates ? { width: "160px" } : { width: "160px", background: '#3a7bbdc4 !important', cursor: "not-allowed", borderColor: '#3a7bbdc4 !important' }}
                                                onClick={() => {
                                                    mailTemplates
                                                        ?
                                                        copyEmailContent()
                                                        : ""
                                                }}>
                                                Copy to Clipboard
                                            </span>
                                        </CopyToClipboard> */}

                                        <CopyToClipboard
                                            text={mailTemplates?.template_body
                                                ?.replace(/<br\s*\/?>/gi, '\n')
                                                ?.replace(/<[^>]+>/g, '') || ''}
                                            onCopy={() => {
                                                toastr.success(props.t("Copied!!"))
                                                 toggle()
                                            }}
                                        >
                                            <span
                                                id="emailContent"
                                                className="btn btn-primary btn-block"
                                                style={mailTemplates
                                                    ? { width: "160px" }
                                                    : { width: "160px", background: '#3a7bbdc4 !important', cursor: "not-allowed", borderColor: '#3a7bbdc4 !important' }}
                                            >
                                                Copy to Clipboard
                                            </span>
                                        </CopyToClipboard>
                                    </div>
                            }

                        </div>


                    </Form>
                </ModalBody>
            </Modal>

        </React.Fragment>
    );
};


MailPopupModal.propTypes = {
    history: PropTypes.object,
    t: PropTypes.any,

};

export default withTranslation()(MailPopupModal);

